import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/css/global.css'
import axios from 'axios'
import { isSuperuser, hasPermission } from './utils/auth'
import { InfiniteScroll } from 'element-ui'
// 添加到Vue原型
Vue.prototype.$isSuperuser = isSuperuser
Vue.prototype.$hasPermission = hasPermission
Vue.directive('InfiniteScroll', InfiniteScroll)

// 添加全局权限指令
Vue.directive('permission', {
    inserted(el) {
        if (!isSuperuser()) {
            el.parentNode.removeChild(el)
        }
    }
})

//Vue.prototype.apiUrl = 'https://'      //全局api地址，跟路径，不带/，例如https://baidu.com   https://wechat.unionpharm.net/api/
Vue.prototype.apiUrl = 'https://hms.bupf.net/'
axios.defaults.baseURL = 'https://hms.bupf.net/';   //拦截器地址配置，根路径，携带/

//请求拦截器
axios.interceptors.request.use(function (config) {
    config.headers.Authorization = localStorage.getItem('adminToken');
    return config
}, function (err) {
    this.$router.push('/login');
})
//响应拦截器
axios.interceptors.response.use(function (res) {
    if (res.data.code == 403) {
        Vue.prototype.$message.error("请先登录");
        
        this.$router.push('/login');
    } else {
        return res
    }
}, function (err) {
    // 打印完整错误信息，方便定位
    console.error('请求错误详情:', err.response || err);
  
    // 区分错误类型，避免误导
    if (err.response) {
      const status = err.response.status;
      const data = err.response.data;
      if (status === 401) {
        Vue.prototype.$message.error("登录已过期，请重新登录");
        router.push('/login');
      } else if (status === 403) {
        Vue.prototype.$message.error("权限不足，无法访问");
      } else {
        Vue.prototype.$message.error(`请求失败（${status}）: ${data?.message || '服务器错误'}`);
      }
    } else {
      Vue.prototype.$message.error("网络错误，无法连接服务器");
    }
    return Promise.reject(err);
  })

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

// 引入富文本组件
import QuillEditor from 'vue-quill-editor'
// 引入富文本组件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(QuillEditor)


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
